export const formErrorMessages = {
  required: "Polje je obavezno.",
  invalidEmail: "Unesena adresa nije ispravna. Molimo probajte ponovno.",
  invalidOib: "Uneseni OIB nije ispravan. Molimo probajte ponovno.",
  invalidPassword: "Unesena lozinka nije ispravna. Molimo probajte ponovno.",
  invalidPhone: "Neispravan broj",
  invalidRoleSelection: "Potrebno je odabrati kategoriju",
  invalidEmailFormat: "Email nije u dobrom formatu",
  missingRegistrationToken: "Potrebno je pristupiti registraciji preko ePoljoprivreda sustava"
};
